module.exports = __webpack_public_path__ + "img/headphone-half.33e71e53.png";